module.exports = __webpack_public_path__ + "img/kn19_samurai01skin_shop.2dfca960.png";